import { useCallback } from 'react';
import { ListActionTarget } from '../../../models/ListActionTarget';
import { AddToCartOrListActionType } from './addToCartOrListReducer';
import { useGlobalContext } from '../GlobalContextProvider';

export const useListActionTarget = () => {
    const { state, dispatch } = useGlobalContext();

    const target = state.addToCartOrList.target;
    const targetSelectionListId = state.addToCartOrList.targetSelectionListId;

    const setTarget = useCallback(
        (newTarget: ListActionTarget) => {
            dispatch({ type: AddToCartOrListActionType.CHANGE_TARGET, target: newTarget });
        },
        [dispatch]
    );

    const setTargetSelectionList = useCallback(
        (selectionListId: string) =>
            dispatch({
                type: AddToCartOrListActionType.SET_TARGET_SELECTION_LIST_ID,
                selectionListId
            }),
        [dispatch]
    );

    return {
        target,
        setTarget,
        setTargetSelectionList,
        targetSelectionListId
    };
};
